<ds-panel [toggleable]="true" [collapsed]="isCollapsed">
  <ds-panel-header>
    {{ 'dodajPodmiotDoMonitorowania' | transloco }}
  </ds-panel-header>
  <ds-panel-buttons>
    <p class="subscriptions p-mr-3">{{ 'liczbaAktywnychSubskrypcji' | transloco }} <span class="subscriptionsNumber p-ml-2">{{ activeSubscriptions }}/{{ maxSubscriptions }}</span></p>
  </ds-panel-buttons>
  <div class="p-row p-d-flex p-align-end p-flex-wrap">
    <div class="p-col-12 p-md-2 p-pl-0">
      <ds-krs label="{{'numerKrs' | transloco}}" placeholder="__________" [autoFocus]="true"
        (keyup.enter)="handleSearch()" [formControl]="searchControl"></ds-krs>
    </div>
    <div class="p-col-12 p-md-4 p-pl-0">
      <ds-button label="wyszukajWKrs" 
        [disabled]="isButtonDisabled"
        [loading]="loading$ | async"
        (onClick)="handleSearch()" 
      ></ds-button>
    </div>
  </div>

  <app-instrukcja [heading]="'uwaga'" [note]='("instrukcjaWyszukiwaniaPodmiotu" | transloco) + " " + wyszukiwarkaUrl'></app-instrukcja>

  <div class="row" *ngIf="errorMessage$ | async as errorMessage">
    <app-instrukcja [heading]="errorMessage.heading" [note]="errorMessage.note"></app-instrukcja>
  </div>

  <ng-container *ngIf="!(loading$ | async) else loaderTmpl">
    <div class="row podmiot-row" *ngIf="podmiot$ | async as podmiot">
      <div class="wrapper">
        <div class="p-grid">
          <div class="p-col-12">
            <ds-input label="{{'nazwa' | transloco}}" [ngModel]="podmiot.dzial1?.danePodmiotu?.nazwa" [disabled]="true">
            </ds-input>
          </div>
          <div class="p-col-12 p-md-6">
            <ds-input label="{{'rodzajOrganizacji' | transloco}}" [ngModel]="podmiot.dzial1?.danePodmiotu?.formaPrawna"
              [disabled]="true">
            </ds-input>
          </div>
          <div class="p-col-12 p-md-3">
            <ds-input label="{{'nip' | transloco}}" [ngModel]="podmiot.dzial1?.danePodmiotu?.nip" [disabled]="true">
            </ds-input>
          </div>
          <div class="p-col-12 p-md-3">
            <ds-input label="{{'numerRegon' | transloco}}" [ngModel]="podmiot.dzial1?.danePodmiotu?.regon"
              [disabled]="true">
            </ds-input>
          </div>
        </div>
        <div class="p-grid p-mt-2">
          <div class="p-col-12 p-d-flex p-justify-end">
            <ds-button (click)="add()" label="{{'monitoruj' | transloco}}"></ds-button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #loaderTmpl>
    <ds-loader class="loader wrapper"></ds-loader>
  </ng-template>
</ds-panel>

<ds-modal #modal>
  <div dsModalTitle>{{ 'monitorowaniePodmiotu' | transloco }}</div>
  <div dsModalContent>
    <app-monitorowanie-podmiotu-form [monitorowanieForm]="monitorowaniePodmiotuForm"></app-monitorowanie-podmiotu-form>
    <div class="p-mt-4 p-d-flex p-flex-row p-jc-end">
      <div class="p-mr-2">
        <ds-button severity="border" [label]="'anuluj' | transloco" (onClick)="hideModal()"></ds-button>
      </div>
      <div class="p-mr-3">
        <ds-button severity="primary" [disabled]="monitorowaniePodmiotuForm?.invalid" [label]="'zapiszZmiany' | transloco" (onClick)="save(monitorowaniePodmiotuForm)"></ds-button>
      </div>
    </div>
  </div>
</ds-modal>
